import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import authService from "../../services/auth.service";
import ToastComponent from "../Common/TaostComponent";

const AccountVerification = (props) => {
  let params = useParams(); // calling the hook
  const verificationLink = params.verificationLink;

  const navigate = useNavigate();
  useEffect(() => {
    authService.accountVerification(verificationLink).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, "success");
        navigate("/login");
      }
    });
  }, [verificationLink, navigate]);
  return "Loading...";
};

export default AccountVerification;
